export const SAAS_OPEN_TABS = 'SAAS_OPEN_TABS'; // 用户打开的TAB
export const SAAS_CURRENT_TAB = 'SAAS_CURRENT_TAB'; // 用户打开的当前TAB
export const SAAS_MENU = 'SAAS_MENU'; // 用户菜单 控制台菜单

export const SAAS_TOKEN = 'accessAdmintoken'; // 用户TOKEN
export const SAAS_REFRESH_TOKEN = 'refreshAdmintoken'; // 长token
export const SAAS_CURRENT_MENU = 'SAAS_CURRENT_MENU'; // 当前一级菜单

export const SAAS_CURRENT_SUBMENU = 'SAAS_CURRENT_SUBMENU'; // 当前二级菜单
export const SAAS_CURRENT_LEVEL_ONE_MENU = 'SAAS_CURRENT_LEVEL_ONE_MENU'; // 当前一级菜单

export const SAAS_CURRENT_LEVEL_TOP_MENU = 'SAAS_CURRENT_LEVEL_TOP_MENU'; // 当前顶级菜单

export const SAAS_USER_FUNCTIONS = 'SAAS_USER_FUNCTIONS'; //用户的功能权限

export const SAAS_USER_INFO = 'userInfo'; // 用户信息
export const SAAS_USER_NAME = 'SAAS_USER_NAME'; // 用户登陆账号
export const FORMAT_MENU = 'FORMAT_MENU'; //  格式化菜单

export const CMA_ORDER_INFO = 'CMA_ORDER_INFO'; //  CMA代报名数据
export const CMA_ORDER_INFO_FLAG = 'CMA_ORDER_INFO_FLAG'; //  CMA代报名数据

export const AMAC_ORDER_SEARCH = 'AMAC_ORDER_SEARCH'; // AMAC代报名查询字段
export const AMAC_ORDER_SEARCH_FLAG = 'AMAC_ORDER_SEARCH_FLAG'; // AMAC代报名查询字段标记


// WEBPACK FOOTER //
// ./src/js/util/keys.js